export function parseTimespan(timeSpanStr) {
	if (timeSpanStr && (timeSpanStr.days  || timeSpanStr.hours || timeSpanStr.minutes || timeSpanStr.seconds || timeSpanStr.minutes)) return timeSpanStr

	// Expected format: "ddd.hh:mm:ss"
	const match = timeSpanStr.match(/^(\d+)\.(\d{2}):(\d{2}):(\d{2})$/);
	if (!match) return null;

	const [, days, hours, minutes, seconds] = match.map(Number);

	return {
		days,
		hours,
		minutes,
		seconds
	};
}

export function stringifyInterval(interval) {
	if (typeof interval === 'string') return interval;
	const { days = 0, hours = 0, minutes = 0, seconds = 0 } = interval
	const pad = (n) => String(n).padStart(2, "0");
	return `${days}.${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function formatInterval(interval) {
	const isPositive = interval.days > 0 || interval.hours > 0 || interval.minutes > 0

	const totalDays = Math.abs(interval.days) || 0;
	const totalMinutes = Math.abs(interval.minutes) || 0;

	let periodStr = ''

	if (totalMinutes > 0)  periodStr = `${totalMinutes}min`;
	if (totalDays === 1) periodStr = `${totalDays} day`;
	else if (totalDays > 1) periodStr = `${totalDays} days`;

	return isPositive ? periodStr : "-" + periodStr;
}

export function formatTimespan(timeSpanStr) {
	return formatInterval(parseTimespan(timeSpanStr));
}

export function sortRenewalReminders(reminders) {
	// ensure it's in the interval format
	const mappedToInterval = reminders.map(x => {
		return {
			...x,
			interval: parseTimespan(x.interval)
		}
	});

	// Sort descending by interval
	return mappedToInterval.sort((a, b) => {
		const aDays = a.interval.days || 0;
		const bDays = b.interval.days || 0;
		return bDays - aDays;
	});
}